<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="600px"
  >
    <v-card>
      <v-card-text>
        <v-container>
          <v-form
            ref="formNewEntidadTecnica"
            lazy-validation
            @submit.prevent="save()"
          >
            <v-card-title class="pa-2">
              {{ isEdit ? 'Modificar entidad técnica' : 'Crear entidad técnica' }}
              <v-spacer />
            </v-card-title>

              <v-text-field
                v-model="ruc"
                label="Ruc"
                class="px-2 py-1"
                :disabled="hasRuc"
                :loading="loadingRuc"
                flat
                outlined
                required
                :rules="[v => !!v || 'El RUC es obligatorio']"
                @change="consultarRuc(ruc)"
              />

                <!-- :disabled="datosRuc" -->
              <v-text-field
                v-model="razonSocial"
                class="px-2 py-1"
                flat
                label="Razon Social"
                outlined
                :rules="[v => !!v || 'La razon social es obligatorio']"
                required
              />

                <!-- :disabled="datosRuc" -->
              <v-text-field
                v-model="direccionFiscal"
                label="Direccion Fiscal"
                class="px-2 py-1"
                flat
                required
                :rules="[v => !!v || 'La direccion Fiscal es obligatorio']"
                outlined
              />

              <v-text-field
                v-model="representanteLegal"
                class="px-2 py-1"
                flat
                label="Representante Legal"
                required
                :rules="[v => !!v || 'El representante legal es obligatorio']"
                outlined
              />

              <v-text-field
                v-model="direccionReal"
                class="px-2 py-1"
                flat
                label="Direccion Real"
                required
                :rules="[v => !!v || 'La dirreccion real es obligatorio']"
                outlined
              />

            <v-row no-gutters>
              <v-col cols="6">
                <v-select
                  v-model="estadoSeleccionado"
                  class="px-2 py-1"
                  outlined
                  :items="estadosEntidadTecnica"
                  label="Estado de la entidad tecnica"
                  :rules="[v => !!v || 'El estado es obligatorio']"
                />
              </v-col>
                <!-- <v-col cols="6">
                <v-select
                  v-model="etapaDeObraSeleccionada"
                  class="px-2 py-1"
                  outlined
                  :items="etapasDeObra"
                  label="Seleccione etapa de obra"
                  :rules="[v => !!v || 'La etapa de obra es obligatoria']"
                />
              </v-col> -->
              <v-col cols="6">
                <v-select
                  v-model="medioDeContactoSeleccionado"
                  class="px-2 py-1"
                  outlined
                  :items="medioDeContacto"
                  label="Medio de Contacto"
                  :rules="[v => !!v || 'El medio de contacto es obligatorio']"
                />
              </v-col>
            <!-- </v-row> -->

            <!-- <v-row> -->
              <v-col cols="6">
                <v-select
                  v-model="zona"
                  class="px-2 py-1"
                  label="Zona"
                  :items="zonas"
                  :rules="[v => !!v || 'La zona es obligatorio']"
                  outlined
                />
              </v-col>
              <v-col cols="6">
                  <v-select
                  v-model="vigente"
                  class="px-2 py-1"
                  outlined
                  label="seleccione vigencia en el FMV"
                  :items="vigencias"
                  :rules="[v => !!v || 'seleccione vigencia en el FMV es requerido']"
                />
              </v-col>
            <!-- </v-row> -->

            <!-- <v-row> -->
              <v-col cols="6">
                <v-select
                  v-model="departamentoFiscal"
                  class="px-2 py-1"
                  outlined
                  flat
                  :items="departamentos"
                  label="Seleccione departamento fiscal"
                  :rules="[v => !!v || 'Seleccionar departamento fiscal es obligatorio']"
                  @change="onChangeRegion"
                />
              </v-col>
              <v-col cols="6">
              <v-select
                v-model="provinciaFiscal"
                class="px-2 py-1"
                outlined
                flat
                :items="provincias"
                label="Seleccione la provincia Fiscal (Excepto region Lima, Seleccione distrito)"
                :rules="[v => !!v || 'Seleccionar la provincia Fiscal es obligatorio']"
              />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="proveedorActual"
                  class="px-2 py-1"
                  flat
                  label="Proveedor actual"
                  required
                  :rules="[v => !!v || 'El proveedor actual es obligatorio']"
                  outlined
                />
              </v-col>
              <v-col cols="6">
              <v-select
                v-model="tipoDeContruccion"
                class="px-2 py-1"
                outlined  
                flat
                :items="['CSP','AVN']"
                label="Seleccione tipo de construccion"
                :rules="[v => !!v || 'Seleccionar tipo de construccion es obligatorio']"
                required
              />
              </v-col>
            <!-- </v-row> -->

            <!-- <v-row> -->
              <v-col cols="6">
              <v-select
                v-if="isAdmin && isEdit"
                v-model="email"
                class="px-2 py-1"
                outlined
                flat
                :items="users"
                label="Usuario a cargo"
              />
                <!-- @change="getUserByEmail" -->
              </v-col>
            </v-row>

            <v-card-actions class="pa-2">
              <v-btn
                outlined
                @click="close"
              >
                Cancelar
              </v-btn>
              <v-spacer />
              <v-btn
                color="primary"
                type="submit"
                :loading="loading"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>

    <v-snackbar
      v-model="snackbar"
    >
    {{ snackbarTxt }}
  </v-snackbar>

  </v-dialog>
            <!-- </v-card-text> -->
</template>

<script>
  // import { doc, setDoc, Timestamp } from 'firebase/firestore'
  import firebase from 'firebase'
  // import axios from 'axios'
  const db = firebase.firestore()

  export default {
    data () {
      return {
        users: [],
        departamentos: [],
        provincias: [],
        entidadTecnica: undefined,
        loading: false,
        datosRuc: true,
        ruc: undefined,
        razonSocial: '',
        representanteLegal: '',
        direccionFiscal: '',
        verificadoDireccionFiscalGPS: '',
        direccionReal: '',
        verificadoDireccionRealGPS: '',
        zona: '',
        estadosEntidadTecnica: '',
        estadoSeleccionado: '',
        medioDeContactoSeleccionado: '',
        medioDeContacto: '',
        dialog: false,
        email: '',
        uidByEmail: '',
        vigente: '',
        vigencias: [],
        zonas: [],
        departamentoFiscal: '',
        provinciaFiscal: '',
        fotoDireccionFiscal: '',
        fotoDireccionReal: '',
        tipoDeCliente: '',
        convocatorias: [],
        proveedorActual: '',
        tipoDeContruccion: '',
        // etapaDeObraSeleccionada: '',
        etapasDeObra: [],
        loadingRuc: false,
        snackbar: false,
        snackbarTxt: '',
      }
    },
    computed: {
      isEdit () {
        return this.entidadTecnica === undefined ? false : 'qw'
      },
      hasRuc () {
        return this.entidadTecnica?.ruc ? true : null
      },
      isAdmin () {
        return JSON.parse(localStorage.userAuth).perfil !== 'Administrador' ? false : 'a'
      },
    },
    mounted () {
      this.medioDeContacto = this.$store.state.medioDeContactoEntidadTecnica
      this.estadosEntidadTecnica = this.$store.state.estadosEntidadTecnica
      this.vigencias = this.$store.state.vigenciaEntidadTecnica
      this.zonas = this.$store.state.zonaEntidadTecnica
      this.etapasDeObra = this.$store.state.etapaDeObraEntidadTecnica
      this.getUsers()
      this.getDepartamentos()
      // this.uidByEmail = JSON.parse(localStorage.userAuth).uid
    },
    methods: {
      async open (entidadTecnica) {
        this.dialog = true
        this.entidadTecnica = entidadTecnica
        if (this.isEdit) {
          this.uidByEmail = entidadTecnica.userId
          this.email = entidadTecnica.email_user
          // this.getUser(entidadTecnica)
          this.ruc = entidadTecnica.ruc
          this.razonSocial = entidadTecnica.razon_social
          this.representanteLegal = entidadTecnica.representante_legal
          this.direccionFiscal = entidadTecnica.direccion_fiscal
          this.direccionReal = entidadTecnica.direccion_real
          this.zona = entidadTecnica.zona
          this.vigente = entidadTecnica.vigencia
          this.medioDeContactoSeleccionado = entidadTecnica.medio_de_contacto
          this.estadoSeleccionado = entidadTecnica.estado
          this.proveedorActual = entidadTecnica.proveedor_actual
          this.tipoDeContruccion = entidadTecnica.tipo_de_construccion
          // this.etapaDeObraSeleccionada = entidadTecnica.etapaDeObra
          if (entidadTecnica?.departamento_fiscal) {
            this.departamentoFiscal = entidadTecnica?.departamento_fiscal
          }
          if (entidadTecnica?.provincia_fiscal) {
            this.provinciaFiscal = entidadTecnica?.provincia_fiscal.trim()
            var privinciaSeleccionadaByFiltro = await this.$store.state.regiones.filter(region => region.NOMBRE === entidadTecnica?.departamento_fiscal)
            this.provincias = privinciaSeleccionadaByFiltro[0]?.PROVINCIAS
          }
        }
      },
      close () {
        this.$refs.formNewEntidadTecnica.reset()
        this.dialog = false
        this.loading = false
      },
      getDepartamentos () {
        this.departamentos = []
        this.$store.state.regiones.forEach(region => {
          this.departamentos.push(region.NOMBRE)
        })
      },
      onChangeRegion () {
        var privinciaSeleccionadaByFiltro = this.$store.state.regiones.filter(region => region.NOMBRE === this.departamentoFiscal)
        this.provincias = privinciaSeleccionadaByFiltro[0].PROVINCIAS
      },
      getUser (item) {
        db.collection('users').where('uid', '==', item.userId).get().then(users => {
          users.forEach(user => {
            this.email = user.data().email
          })
        })
      },
      getUserByEmail (email) {
        db.collection('users').where('email', '==', email).get().then(users => {
          users.forEach(user => {
            this.uidByEmail = user.data().uid
          })
        })
      },
      getUsers () {
        db.collection('users').get().then(users => {
          users.forEach(user => {
            this.users.push(user.data().email)
          })
        })
      },
      async consultarRuc (ruc) {
        this.loadingRuc = true
        try {
          const response = await fetch(process.env.VUE_APP_BASE_URL_RUC,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                ruc: ruc.trim()
              })
            })
          const data = await response.json()
          if (data.data.result?.RazonSocial) {
            this.razonSocial = data.data.result.RazonSocial
            this.direccionFiscal = data.data.result.Direccion + ' ' + data.data.result.departamento + ' - ' + data.data.result.provincia + ' - ' + data.data.result.distrito
          } else {
            this.razonSocial = ''
            this.direccionFiscal = ''
          }
        } catch (error) {
        }
        this.loadingRuc = false
      },
      async save () {
        if (this.$refs.formNewEntidadTecnica.validate() && this.isEdit === false) {
          const idDoc = this.ruc.toString().trim()

          this.loading = true
          // const newEntidadTecnica = firebase.firestore().collection('EntidadesTecnicas').doc(idDoc)
          // newEntidadTecnica.set({
          //   id: idDoc,
          //   ruc: this.ruc,
          //   razonSocial: this.razonSocial,
          //   representanteLegal: this.representanteLegal,
          //   direccionFiscal: this.direccionFiscal,
          //   direccionFiscalGPS: {
          //   Latitud: '',
          //   Longitude: '',
          //   },
          //   fotoDireccionFiscal: '',
          //   verificadoDireccionFiscalGPS: false,
          //   direccionReal: this.direccionReal,
          //   direccionRealGPS: {
          //   Latitude: '',
          //   Longitude: '',
          //   },
          //   fotoDireccionReal: '',
          //   verificadoDireccionRealGPS: false,
          //   zona: this.zona,
          //   vigencia: this.vigente,
          //   departamentoFiscal: this.departamentoFiscal,
          //   provinciaFiscal: this.provinciaFiscal,
          //   estado: this.estadoSeleccionado,
          //   medioDeContacto: this.medioDeContactoSeleccionado,
          //   tipoDeCliente: '',
          //   convocatorias: [],
          //   cantidadDeModulos: [],
          //   proveedorActual: this.proveedorActual,
          //   tipoDeContruccion: this.tipoDeContruccion,

          //   userId: JSON.parse(localStorage.userAuth).uid,
          //   emailUser: JSON.parse(localStorage.userAuth).email,
          // }, { merge: true })
          //   .then((docRef) => {
          //     this.close()
          //     this.$emit('onCreate')
          //   })

          const payload = {
            // id: idDoc,
            departamento_fiscal: this.departamentoFiscal,
            direccion_fiscal: this.direccionFiscal,
            latitud_fiscal_gps: '',
            longitud_fiscal_gps: '',
            direccion_real: this.direccionReal,
            latitud_real_gps: '',
            longitud_real_gps: '',
            estado: this.estadoSeleccionado,
            foto_direccion_fiscal: '',
            foto_direccion_real: '',
            medio_de_contacto: this.medioDeContactoSeleccionado,
            proveedor_actual: this.proveedorActual,
            provincia_fiscal: this.provinciaFiscal,
            representante_legal: this.representanteLegal,
            razon_social: this.razonSocial,
            ruc: idDoc,
            tipo_de_cliente: '',
            tipo_de_construccion: this.tipoDeContruccion,
            verificado_direccion_fiscal_gps: false,
            verificado_direccion_real_gps: false,
            zona: this.zona,
            vigencia: this.vigente,
            // convocatorias: [],
            // cantidadDeModulos: [],

            // userId: JSON.parse(localStorage.userAuth).uid,
            email_user: JSON.parse(localStorage.userAuth).email,
          }

          const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/entidad',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(payload)
            })

          const data = await response.json()
          if (data.success) {
              this.loading = false
              this.close()
              this.$emit('onCreate')
            } else {
              this.snackbar = true
              this.snackbarTxt = 'La entidad tecnica ya existe'
              this.loading = false
            }
        } else {
          if (this.$refs.formNewEntidadTecnica.validate() && this.isEdit) {
            this.loading = true

            // // await this.getUserByEmail(this.email)
            // const entidadTecnicaUpdate = firebase.firestore().collection('EntidadesTecnicas').doc(this.entidadTecnica.id)
            // entidadTecnicaUpdate.set({
            //   ruc: this.ruc,
            //   razonSocial: this.razonSocial,
            //   representanteLegal: this.representanteLegal,
            //   direccionFiscal: this.direccionFiscal,
            //   direccionReal: this.direccionReal,
            //   zona: this.zona,
            //   estado: this.estadoSeleccionado,
            //   medioDeContacto: this.medioDeContactoSeleccionado,
            //   vigencia: this.vigente,
            //   departamentoFiscal: this.departamentoFiscal,
            //   provinciaFiscal: this.provinciaFiscal,
            //   proveedorActual: this.proveedorActual,
            //   tipoDeContruccion: this.tipoDeContruccion,
            //   // etapaDeObra: this.etapaDeObraSeleccionada,
            //   // userId: this.uidByEmail,
            //   emailUser: this.email,

            // }, { merge: true })
            //   .then((docRef) => {
            //     this.close()
            //     this.$emit('onCreate')
            //   })
            const payload = {
              // id: this.entidadTecnica.id,
              departamento_fiscal: this.departamentoFiscal,
              direccion_fiscal: this.direccionFiscal,
              direccion_real: this.direccionReal,
              estado: this.estadoSeleccionado,
              medio_de_contacto: this.medioDeContactoSeleccionado,
              proveedor_actual: this.proveedorActual,
              provincia_fiscal: this.provinciaFiscal,
              representante_legal: this.representanteLegal,
              razon_social: this.razonSocial,
              ruc: this.ruc,
              tipo_de_construccion: this.tipoDeContruccion,
              // verificado_direccion_fiscal_gps: false,
              // verificado_direccion_real_gps: false,
              zona: this.zona,
              vigencia: this.vigente,
              // convocatorias: [],
              // cantidadDeModulos: [],

              // userId: this.uidByEmail,
              email_user: this.email,
            }
            const response = await fetch(process.env.VUE_APP_BASE_URL_BACKEND + '/entidad/' + this.entidadTecnica.id,
              {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
              })
            const data = await response.json()
            if (data.success) {
              this.loading = false
              this.close()
              this.$emit('onCreate')
            } else {
              this.loading = false
            }
          }
        }
      },
    },

  }
</script>

<style>
</style>
